import React from "react";
import { Row, Col } from "antd";
import "./index.css";
import ExaltProjectImg from "../../assets/images/exalt.png";
import ChefProjectImg from "../../assets/images/Chef.png";
import ExaltoodProjectImg from "../../assets/images/Exalt_Food.png";
import GamingProjectImg from "../../assets/images/Gaming.png";
import Button from "../../components/button/button";
import { FiExternalLink } from "react-icons/fi";
import Slider from "react-slick";
import nav1 from "../../assets/images/nav1.svg";
import nav2 from "../../assets/images/nav2.svg";

const Projects: React.FC = () => {
  function SampleNextArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <img
        src={nav1}
        alt=""
        className={className}
        style={{ ...style, display: "block", color: "red", width: 35 }}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <img
        src={nav2}
        alt=""
        className={className}
        style={{ ...style, display: "block", color: "red", width: 35 }}
        onClick={onClick}
      />
    );
  }

  const settings = {
    dots: false,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    infinite: true,
    autoplay: true,
    // fade: true,
    // vertical: true,
    // verticalSwiping: true,
    autoplaySpeed: 6000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  interface Project {
    img: string;
    title: string;
    desc: string;
    job_role: string;
    duration: string;
    techs: string[];
    link: string;
  }

  const projects: Project[] = [
    {
      img: ExaltProjectImg,
      title: "Exalt Solutions",
      desc:
        "Exalt Solution website portrays the ability of the company to build elevated digital solutions with the top technologies around the world and also gives and insight of the accomplishment of the company.",
      job_role: "Front-End Developer",
      duration: "2 days",
      techs: ["NEXTJS", "REACT STRAP", "REDUX"],
      link: "https://exaltapp.netlify.app/",
    },
    {
      img: ChefProjectImg,
      title: "Chef ng",
      desc:
        "Cheef is a technology company that connects local consumers and local cooks/chefs. Cheef gives local consumers the easy way out when they are hungry but feel tired. Consumers can order a cheef from the comfort of their home to come help out with the cooking at home and these chefs pass through a series of examinations which makes gives the company assurance of who they have on ground.",
      job_role: "Front-End Developer",
      duration: "6 months",
      techs: ["NEXTJS", "REACT STRAP"],
      link: "https://cheef.ng/",
    },
    {
      img: ExaltoodProjectImg,
      title: "Exalt foods",
      desc:
        "Exalt foods is an upcoming application which helps restaurants and consumers all over the world have access to what ever they want to eat by just having a smart phone. This application also gives consumers and restaurants the ability to track their delivery real time which in the other hand brings confidence and more safety between a distributor and it’s consumer.",
      job_role: "Front-End Developer",
      duration: "8 months",
      techs: ["NEXTJS", "ANT DESIGN", "REDUX"],
      link: "https://exalt-foods.netlify.app/",
    },
    {
      img: GamingProjectImg,
      title: "Playar one",
      desc:
        "Playar One is a gaming website which brings gamers from all over the globe  to participate in various price winning competitions on going on varieties of games.",
      job_role: "Front-End Developer",
      duration: "3 months",
      techs: ["REACT", "ANT DESIGN"],
      link: "https://playarone.netlify.app/",
    },
  ];

  return (
    <div className="project_container">
      <h2>My Works</h2>
      <p>Explore all my works past and present. </p>
      <Slider {...settings}>
        {projects.map((project, i) => (
          <Row gutter={[16, 16]} className="row" key={i}>
            <Col xs={24} sm={24} md={24} lg={10} xl={10} className="cols_img">
              <img src={project.img} alt="" className="project_img" />
            </Col>
            <Col xs={24} sm={24} md={24} lg={14} xl={14} className="cols">
              <h1>
                {project.title} <FiExternalLink size={40} />
              </h1>
              <p>{project.desc}</p>
              <Row gutter={[16, 16]} style={{ marginBottom: "10px" }}>
                <Col xs={24} sm={12} md={24} lg={10} xl={12}>
                  <h5>Job Role:</h5>
                  <p>{project.job_role}</p>
                </Col>
                <Col xs={24} sm={12} md={24} lg={10} xl={12}>
                  <h5>Duration:</h5>
                  <p>{project.duration}</p>
                </Col>
                <Col xs={24} sm={24} md={24} lg={10} xl={12}>
                  <h5>Technologies Used</h5>
                  <ul>
                    {project.techs.map((tech, index) => (
                      <li key={index}>{tech}</li>
                    ))}
                  </ul>
                </Col>
              </Row>

              <Button
                label="View Site"
                handleClick={() => {
                  window.open(project.link, "_blank");
                }}
              />
            </Col>
          </Row>
        ))}
      </Slider>
    </div>
  );
};

export default Projects;
